import { PerfectLookOptionsType } from './types';

export const PERFECT_LOOK_OPTIONS: PerfectLookOptionsType = [
  {
    id: 'elegant_stylish',
    title: 'Elegant and stylish',
  },
  {
    id: 'athletic_colorful_hair',
    title: 'Athletic with colorful hair',
  },
  {
    id: 'glamorous_coquette',
    title: 'Glamorous coquette',
  },
  {
    id: 'natural_beauty_no_makeup',
    title: 'Natural beauty with no makeup',
  },
];
